import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
import { homeProcessSteps } from '../data/sharedSteps';

const ProcessSteps = ({ steps = homeProcessSteps }) => {
  const containerRef = React.useRef(null);
  const isInView = useInView(containerRef, { once: true, amount: 0.3 });

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: custom * 0.2,
        duration: 0.7,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="max-w-7xl mx-auto px-4 w-full" dir="rtl">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
        השלבים בתהליך
      </h2>
      <div
        ref={containerRef}
        className="flex flex-col md:flex-row md:flex-nowrap items-center md:items-start justify-center gap-8 md:gap-1 lg:gap-2"
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <motion.div
              custom={index}
              variants={itemVariants}
              initial="hidden"
              animate={isInView ? 'visible' : 'hidden'}
              className="flex-shrink-0 md:flex-1 md:min-w-0 flex flex-col items-center text-center max-w-[180px] md:max-w-none px-1"
            >
              <div className="w-16 h-16 rounded-full bg-gray-800 text-white flex flex-col items-center justify-center shadow-lg transform transition-transform hover:scale-110">
                <span className="text-sm font-bold opacity-80">שלב</span>
                <span className="text-xl font-bold">{step.number}</span>
              </div>
              <div className="mt-4 relative">
                <h3 className="text-base md:text-sm lg:text-base font-bold mb-1 flex flex-col items-center justify-center gap-2">
                  {step.title}
                  {step.freeLabel && (
                    <span className="bg-amber-500/10 text-amber-600 text-xs font-semibold px-2 py-1 rounded-full">
                      ללא עלות!
                    </span>
                  )}
                </h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </div>
            </motion.div>
            {index < steps.length - 1 && (
              <motion.div
                custom={index + 0.5}
                variants={itemVariants}
                initial="hidden"
                animate={isInView ? 'visible' : 'hidden'}
                className="transform transition-transform duration-500 ease-in-out md:hover:scale-125 hidden md:flex flex-shrink-0 self-center px-0.5 lg:px-1"
              >
                <ChevronLeft className="w-5 h-5 lg:w-6 lg:h-6 text-amber-500" />
              </motion.div>
            )}
          </React.Fragment>
        ))}
      </div>
      {steps.length > 1 && (
        <div className="md:hidden flex justify-center mt-4">
          <ChevronRight className="w-8 h-8 rotate-90 text-amber-500" />
        </div>
      )}
    </div>
  );
};

export default ProcessSteps;
